<template lang="pug">
#modal-desativar-monitoramento
    el-dialog(
        :title="$t('mensagens.monitoramentoAgricola.desativarMonitoramento')",
        width='500px',
        :visible.sync='mostrar',
        :before-close='fecharModal'
    )
        h3 {{ $tc('mensagens.monitoramentoAgricola.desejaCancelarMonitoramento', areasMonitoradas.length) }}:
        ul
            li(
                v-for='areaMonitorada in areasMonitoradas',
                :key='areaMonitorada.id'
            ) {{ areaMonitorada.territorio.nome }}

        footer.espacamento(slot='footer')
            BaseButton(type='default', size='mini', @click='fecharModal') {{ $t('mensagens.comuns.voltar') }}
            BaseButton(
                type='primary',
                size='mini',
                @click='desativarMonitoramentos',
                :loading='desativando'
            ) {{ $t('mensagens.monitoramentoAgricola.desativar') }}
</template>

<script>
import areasMonitoradasService from '@/services/AreasMonitoradasService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalDesativarMonitoramento',

    components: {
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        areasMonitoradas: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            desativando: false
        };
    },

    methods: {
        async desativarMonitoramentos() {
            this.desativando = true;

            try {
                const idsAreaMonitorada = [];
                this.areasMonitoradas.forEach(({ id }) =>
                    idsAreaMonitorada.push(id)
                );
                await areasMonitoradasService.desativarMonitoramentos({
                    idsAreaMonitorada
                });

                const message = this.$tc('mensagens.monitoramentoAgricola.areasDesativadasComSucesso', this.areasMonitoradas.length);

                this.$notify.success({ message });
                this.$emit('atualizarTabela');
                this.fecharModal();
            } catch (error) {
                const message = this.$tc('mensagens.monitoramentoAgricola.areasNaoDesativadas', this.areasMonitoradas.length);

                this.$notify.error({ message });
            } finally {
                this.desativando = false;
            }
        },

        fecharModal() {
            this.$emit('fechar');
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-diagnostico__btn-confimar {
    display: flex;
    justify-content: center;
}

.espacamento {
    display: flex;
    justify-content: space-between;
}

.modal-diagnostico__btn-exportacao {
    display: flex;
    justify-content: space-between;
}
</style>
